import "./loader.css";

export function Loader() {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
}

export function LoaderButton() {
  return (
    <div className="loader-btn">
      <div className="spinner"></div>
    </div>
  );
}
